//const ef_storySpecial = document.querySelector(".ef-story--special");
//const ef_storyStart = document.querySelector(".ef-story-hero__cta");
//const ef_storyClose = document.querySelector(".ef-story__close");
const ef_story = document.querySelector(".ef-story");
const ef_storyNext = document.querySelector(".ef-story__arrow--next");
const ef_storyPrev = document.querySelector(".ef-story__arrow--prev");
const ef_storyNavNext = document.querySelector(".ef-story__nav--next");
const ef_storyNavPrev = document.querySelector(".ef-story__nav--prev");
let ef_storyIndex = 1;
let storyTimeout;

if (ef_story !== null) {
  window.onload = function () {
    activateStory();
  }

  ef_storyNext.addEventListener("click", event => {
    nextStory();
  });
  
  ef_storyPrev.addEventListener("click", event => {
    prevStory();
  });
  
  ef_storyNavNext.addEventListener("click", event => {
    nextStory();
  });
  
  ef_storyNavPrev.addEventListener("click", event => {
    prevStory();
  });
}

const prevStory = () => {
  if(ef_storyIndex > 1) {
    clearTimeout(storyTimeout);
    ef_storyIndex--;
    setCurrentStory();
    activateStory();
  }
}

const nextStory = () => {
  if(ef_storyIndex <= 12){
    clearTimeout(storyTimeout);
    ef_storyIndex++;
    setCurrentStory();
    activateStory();
  }
}

const setCurrentStory = () => {
  document.querySelector('.ef-story__pages--current').textContent = ef_storyIndex.toString();
  document.querySelectorAll('.ef-story__step').forEach((el, i) => {
    el.classList.remove('--is-current','--is-complete');
    if(i < ef_storyIndex - 1){
      el.classList.add("--is-complete");
    }else if(i === ef_storyIndex - 1){
      el.classList.add("--is-current");
    }
  })
  document.querySelectorAll('.ef-story__chapter').forEach((el, i) => {
    if(i === ef_storyIndex - 1){
      el.classList.add('--is-active');
    }else{
      el.classList.remove('--is-active');
    }
  })
}

const activateStory = () => {
  if(ef_storyIndex <= 12){
    storyTimeout = setTimeout(() => {
      let currentStory = document.querySelector('.ef-story__chapter[data-story="europa-'+ ef_storyIndex.toString() +'"]');
      let currentStep = document.querySelector('.ef-story__step[data-story="europa-'+ ef_storyIndex.toString() +'"]');
      let nextStory = document.querySelector('.ef-story__chapter[data-story="europa-'+ (ef_storyIndex + 1).toString() +'"]');
      let nextStep = document.querySelector('.ef-story__step[data-story="europa-'+ (ef_storyIndex + 1).toString() +'"]');
      document.querySelector('.ef-story__pages--current').textContent = (ef_storyIndex + 1).toString();

      currentStory.classList.remove("--is-active");
      currentStep.classList.remove("--is-current");
      currentStep.classList.add("--is-complete");
      nextStory.classList.add("--is-active");
      nextStep.classList.add("--is-current");
      if(ef_storyIndex >= 12){
        clearTimeout(storyTimeout);
      }else{
        ef_storyIndex++;
        activateStory();
      }
    }, 15000);
  }
}

const hideStories = () => {
  clearTimeout(storyTimeout);
  ef_storyIndex = 1;
  document.querySelector('.ef-story__pages--current').textContent = ef_storyIndex.toString();
  // ef_storySpecial.classList.add("--is-hidden");
  // ef_storySpecial.classList.remove("--is-visible");
  document.querySelector(".ef-content").classList.remove("ef-content--front");
  document.body.classList.remove("--is-frozen");
  document.querySelectorAll('.ef-story__step').forEach((el) => {
    el.classList.remove('--is-current','--is-complete');
  })
  document.querySelector('.ef-story__step[data-story="europa-1"]').classList.add('--is-current');
  document.querySelectorAll('.ef-story__chapter').forEach((el) => {
    el.classList.remove('--is-active');
  })
  document.querySelector('.ef-story__chapter[data-story="europa-1"]').classList.add('--is-active');
}
